import { BigFloat } from '@1inch-community/core/math';
import { isNativeToken } from '../chain';
import { buildTokenIdByToken } from '../tokens';
export class AmountDataSourceImpl {
    constructor(pairHolder, oneInchApiAdapter, wallet, tokenStorage, onChain) {
        this.pairHolder = pairHolder;
        this.oneInchApiAdapter = oneInchApiAdapter;
        this.wallet = wallet;
        this.tokenStorage = tokenStorage;
        this.onChain = onChain;
    }
    async getMaxAmount() {
        const snapshot = this.pairHolder.getSnapshot('source');
        const sourceToken = snapshot.token;
        const connectedWalletAddress = await this.wallet.data.getActiveAddress();
        if (!sourceToken || !connectedWalletAddress)
            return BigFloat.zero();
        let amount = await this.tokenStorage.getTokenBalanceById({
            tokenRecordId: buildTokenIdByToken(sourceToken),
            walletAddress: connectedWalletAddress,
        });
        if (isNativeToken(sourceToken.address)) {
            const chainId = sourceToken.chainId;
            const [gasUnits, gasPriceDTO] = await Promise.all([
                this.onChain.estimateWrapNativeToken(chainId, amount),
                this.oneInchApiAdapter.getGasPrice(chainId),
            ]);
            if (!gasPriceDTO)
                return BigFloat.zero();
            const gasPrice = gasPriceDTO.high;
            const fee = gasUnits.mul(BigFloat.from(gasPrice.maxFeePerGas).add(BigFloat.from(gasPrice.maxPriorityFeePerGas)));
            amount = amount.sub(fee);
            if (amount.isNegative()) {
                amount = BigFloat.zero();
            }
        }
        return amount;
    }
}
//# sourceMappingURL=amount-data-source.impl.js.map